<div class="view-wrapper px-sm-4 mx-sm-auto">
    <dx-toolbar class="theme-dependent" [class.scrolled]="isContentScrolled">
        <dxi-item location="before">
            <div class="header-text">Edit Role</div>
        </dxi-item>
        <dxi-item location="after" locateInMenu="never">
            <dx-button
                text="Cancel"
                stylingMode="outlined"
                type="normal"
                [disabled]="!isDataChanged"
                (onClick)="cancel()"
            >
            </dx-button>
        </dxi-item>
        <dxi-item location="after" locateInMenu="never">
            <dx-button
                [disabled]="!isDataChanged"
                text="Save"
                icon="save"
                type="default"
                stylingMode="contained"
                (onClick)="save()"
            >
            </dx-button>
        </dxi-item>
    </dx-toolbar>

    <dx-load-panel
        container=".view-wrapper-scroll"
        [visible]="isLoading"
        [showPane]="false"
        [position]="{ of: 'user-profile' }"
    >
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">
        @if (!isLoading) {
            <div class="cards-container">
                <profile-card class="profile-card contact-card">
                    <dx-form [formData]="formData" (onFieldDataChanged)="onFieldChange()">
                        <dxo-col-count-by-screen [xs]="1" [sm]="2" [md]="2" [lg]="2"></dxo-col-count-by-screen>
                        <dxi-item
                            dataField="name"
                            editorType="dxTextBox"
                            [isRequired]="true"
                            [editorOptions]="{
                                stylingMode: 'filled'
                            }"
                        >
                        </dxi-item>
                        <dxi-item
                            dataField="description"
                            editorType="dxTextBox"
                            [editorOptions]="{
                                stylingMode: 'filled'
                            }">
                        </dxi-item>
                    </dx-form>
                    <dx-tree-list
                        (onRowDblClick)="onTreeRowDblClick($event)"
                        [dataSource]="permissionTree"
                        keyExpr="id"
                        parentIdExpr="parentId"
                        [showRowLines]="true"
                        [showBorders]="true"
                        [columnAutoWidth]="true"
                        [wordWrapEnabled]="true"
                    >
                        <dxo-scrolling mode="standard" rowRenderingMode="standard"></dxo-scrolling>
                        <dxo-search-panel [visible]="true" placeholder="Search"></dxo-search-panel>
                        <dxo-toolbar>
                            <dxi-item location="before">
                                <div>Permission Matrix</div>
                            </dxi-item>
                            <dxi-item location="after" name="searchPanel"></dxi-item>
                        </dxo-toolbar>
                        <dxi-column dataField="name" caption="Permission / Group" [minWidth]="300"></dxi-column>
                        <dxi-column caption="Access" cellTemplate="accessCell" [width]="550"></dxi-column>
                        <div *dxTemplate="let cellInfo of 'accessCell'">
                            @if (getCellData(cellInfo).isGroup) {
                                <div class="group-access-row d-flex gap-3 align-items-center">
                                    @for (opt of accessOptions; track opt.value) {
                                        <div class="d-flex gap-1 align-items-center">
                                            <dx-check-box
                                                [value]="isGroupChecked(getCellData(cellInfo).name, opt.value)"
                                                (onValueChanged)="toggleGroupAccess(getCellData(cellInfo).name, opt.value, $event)"
                                                [disabled]="getApplicableLinesForAccess(getCellData(cellInfo).name, opt.value).length === 0"
                                                [text]="opt.text"
                                            ></dx-check-box>
                                            @if (this.countGroupSelected(getCellData(cellInfo).name, opt.value) > 0) {
                                                <span class="count-group-selected">
                                                    ({{ this.countGroupSelected(getCellData(cellInfo).name, opt.value) }})
                                                </span>
                                            }
                                        </div>
                                    }
                                </div>
                            } @else {
                                <dx-radio-group
                                    [items]="getCellData(cellInfo).options"
                                    valueExpr="value"
                                    displayExpr="text"
                                    [value]="permissionSelections[getCellData(cellInfo).permissionType]"
                                    layout="horizontal"
                                    (onValueChanged)="onPermissionValueChanged(getCellData(cellInfo).permissionType, $event.value)"
                                >
                                </dx-radio-group>
                            }
                        </div>
                    </dx-tree-list>
                </profile-card>
            </div>
        }
    </dx-scroll-view>
</div>
